import { STATIC_ASSETS_BASE } from './constants';
var metaTags = [
    // Theme color used by PWAs for browser UI
    {
        name: 'theme-color',
        content: '#f2f2f6',
    },
    // Microsoft PWA configuration
    {
        name: 'msapplication-config',
        content: "".concat(STATIC_ASSETS_BASE, "/browserconfig.xml"),
    },
    {
        name: 'application-name',
        content: 'Redbubble',
    },
    {
        httpEquiv: 'x-ua-compatible',
        content: 'IE=edge',
    },
    {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
    },
];
export default metaTags;
